import { cva, VariantProps } from 'class-variance-authority';
import { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../../utils';

const tableCellVariants = cva('flex items-center gap-12', {
  variants: {
    compact: {
      false: 'min-h-[73px] px-8 py-8',
      true: 'min-h-36 px-8',
    },
    disabled: {
      false: '',
      true: '',
    },
  },
  defaultVariants: {
    compact: false,
    disabled: false,
  },
});

const tableCellContentVariants = cva('flex flex-col', {
  variants: {
    align: {
      left: 'items-start',
      center: 'items-center',
      right: 'items-end',
    },
  },
});

export type TableCellVariants = VariantProps<typeof tableCellVariants>;
export type TableCellContentVariants = VariantProps<
  typeof tableCellContentVariants
>;

export type TableCellProps = HTMLAttributes<HTMLTableCellElement> &
  TableCellVariants & {
    children?: ReactNode;
    as?: React.ElementType;
  };

export const TableCell = ({
  className,
  children,
  compact,
  as,
  ...props
}: TableCellProps) => {
  const Component = as ?? 'td';
  return (
    <Component
      {...props}
      className={cn(tableCellVariants({ compact }), className)}
    >
      {children}
    </Component>
  );
};

export type TableCellContentProps = TableCellContentVariants & {
  children: ReactNode;
  className?: string;
};
export const TableCellPrefix = ({
  children,
  className,
  align = 'center',
}: TableCellContentProps) => {
  return (
    <div className={cn(tableCellContentVariants({ align }), className)}>
      {children}
    </div>
  );
};

export const TableCellContent = ({
  children,
  className,
  align = 'left',
}: TableCellContentProps) => {
  return (
    <div
      className={cn(tableCellContentVariants({ align }), 'flex-1', className)}
    >
      {children}
    </div>
  );
};

export const TableCellSuffix = ({
  children,
  className,
  align = 'right',
}: TableCellContentProps) => {
  return (
    <div className={cn(tableCellContentVariants({ align }), className)}>
      {children}
    </div>
  );
};
